import EntityInterface from '../../common/types/entities/EntityInterface'
import createEntitySettings from '../components/core/Sidebar/components/Settings/entities'

export default function createCommonEntityElement(entity: EntityInterface) {
  return createEntitySettings(entity)
}
